import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {documentToHtmlString} from '@contentful/rich-text-html-renderer'
import {resolveGenericContentCta, type GenericContent} from '../../../../../../brand/lib/types/contentful'

import {Heading, Prose, Text} from '@primer/react-brand/esm'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Label} from '../../_shared/Label/Label'
import {Spacer} from '../../_shared/Spacer/Spacer'
import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'
import {Product} from '../../_shared/Product/Product'

import Styles from './River.module.css'

type Props = {
  content: GenericContent
  location: string
  index: number
  sectionIndex: number
}

export function River(props: Props) {
  const {content, index, location, sectionIndex} = props
  const {htmlId, heading, subheading, label, text, media} = content.fields
  const productPlacement = media?.at(0)?.fields.id

  const direction = htmlId // Used for setting left/right alignment

  const title = heading
  const subTitle = subheading ? documentToPlainTextString(subheading) : ''

  const eyebrow = label?.fields.text
  const description = text ? documentToHtmlString(text) : ''

  const ctaGroup = resolveGenericContentCta(content, {legacyFallback: 'first'})

  return (
    <div className={Styles.River} data-direction={direction || (index % 2 === 0 ? 'left' : 'right')}>
      <div className={Styles.Cell}>
        <div className={Styles.Wrapper}>
          {eyebrow && <Label text={eyebrow} />}

          <div className={Styles.Content}>
            {title && (
              <Heading data-heading="2" as={sectionIndex === 0 ? 'h2' : 'h3'}>
                {title}
              </Heading>
            )}

            {subTitle && (
              <>
                <Spacer size="32px" size1280="0" />
                <div>
                  <Text className={Styles.SubTitle} weight="semibold">
                    {subTitle}
                  </Text>
                </div>
              </>
            )}

            {description && (
              <>
                <Spacer size="16px" size1280="24px" />
                <Prose
                  className={Styles.Description}
                  {...(subTitle && {'data-has-subtitle': true})} // Adjust styling if there is a subheading
                  html={description}
                />
              </>
            )}

            {ctaGroup && (
              <>
                <Spacer size="64px" size1280="0" />
                <div>
                  <CtaButtons contentfulContent={ctaGroup} location={location} />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className={Styles.Cell}>
        {media && (
          <Product placement={productPlacement} variant="river">
            <div>
              <div>
                <MediaAsset content={media} location={location} />
              </div>
            </div>
          </Product>
        )}
      </div>
    </div>
  )
}
